// extracted by mini-css-extract-plugin
export default {"heading":"Uy-z","corrected":"Vy-z","redirectVerbiageContainer":"Wy-z","redirectVerbiageText":"Xy-z"};